<template>
    <footer>
        <div class="bg-gray-40 p-4">
            <div class="container">
                <div v-show="selectedlocale.country == 'deu' && selectedlocale.language == 'de'" class="row mb-3 justify-content-center">
                    <div class="col-12 col-lg-5">
                       <!--  <form class="form-inline needs_validation" id="newsletter"
                            action="https://web.inxmail.com/helios/newsletter_anmeldung.jsp" method="post" target="_blank"
                            novalidate> -->
                            <div class="input-group w-100">


                                <label class="mr-3 pt-2">{{ __("lang.kwl.footer.newsletter") }}</label>
                                <b-form-input type="text" class="form-control rounded-left" v-model="input.email" id="input_email" :placeholder="newsletter.placeholder" autocomplete="email" :state="emailState"></b-form-input>

                                <div class="input-group-append">
                    <!--
                                    <button id="heliosNewsletterModalOpen" type="button" class="btn btn-primary w-100 border-0" data-toggle="modal" data-target="#newsletterModal">
                                        <span class="sr-only" data-toggle="modal" data-target="#newsletterModal">{{ __("lang.kwl.footer.newsletter_abo") }}</span>
                                        <svg class="icon m-0">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.mail" xmlns:xlink= "http://www.w3.org/1999/xlink "></use>
                                        </svg>
                                    </button> -->
                                    <a  id="heliosNewsletterModalOpen" role="button" data-toggle="modal"
                                        class="btn btn-primary w-100 border-0" data-target="#newsletterModal" @click="openNewsletterForm">
                                        <span class="sr-only" data-toggle="modal" data-target="#newsletterModal">{{ __("lang.kwl.footer.newsletter_abo") }}</span>
                                        <svg class="icon m-0">
                                                <use xlink:href="/assets/img/icon-sprite.svg#global.mail" xmlns:xlink= "http://www.w3.org/1999/xlink "></use>
                                            </svg>
                                    </a>

                                </div>
                            </div>
                       <!--  </form> -->
                    </div>
                </div>
                <div class="row justify-content-center">
                    <ul class="nav">
                        <li class="nav-item">
                               <!-- <a class="nav-link text_uppercase" href="https://www.heliosventilatoren.de/de/service/kontakt/werkskontakt" target="_blank"></a> -->

                                <a lass="nav-link text_uppercase"
    												:href="contact.href.tocontactpage" @click="gottocontactpage" target="_blank">
                                <svg class="icon icon-xs mr-1">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.arrow"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                                <span>{{ __("lang.kwl.footer.contact") }}</span>
                            </a>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link text_uppercase"
                                href="https://www.youtube.com/user/HeliosVentilatoren/playlists?view=50&amp;sort=dd&amp;shelf_id=12"
                                target="_blank">
                                <svg class="icon icon-xs mr-1">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.arrow"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                                <span>{{ __("lang.kwl.footer.tutorials") }}</span>
                            </a>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
        <nav class="bg-gray-80 py-2 small">
            <div class="container">
                <div class="row align-items-center">
                    <ul class="navbar-nav flex-md-row col-12 col-md-8">
                        <li class="nav-item text-white ml-3 py-2">&copy; {{ __("lang.kwl.footer.company_name") }}</li>
                        <li class="nav-item ml-3">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.heliosventilatoren.de/impressum">{{ __("lang.kwl.footer.impressum") }}</a>
                        </li>
                        <li class="nav-item ml-3">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.heliosventilatoren.de/datenschutz">{{ __("lang.kwl.footer.data_protecten")
                                }}</a>
                        </li>
                        <li class="nav-item ml-3">
                                <a class="nav-link text-white" rel="noopener" onclick="CCM.openWidget(); return false;"
                                    href="#">{{ __("lang.cookies")
                                    }}</a>
                        </li>
                        <li class="nav-item ml-3">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.heliosventilatoren.de/allgemeine-geschaeftsbedingungen-agb">{{
                                    __("lang.kwl.footer.agb") }}</a>
                        </li>
                    </ul>
                    <ul class="navbar-nav flex-row col-12 col-md-4 pl-3 pl-md-0 justify-content-md-end">
                        <li class="nav-item">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.facebook.com/HeliosVentilatoren/"
                                title="Helios Ventilatoren GmbH + Co. KG bei Facebook">
                                <span class="sr-only">{{ __("lang.kwl.footer.facebook") }}</span>
                                <svg class="icon icon-sm">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.social.facebook"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.instagram.com/heliosventilatoren"
                                title="Helios Ventilatoren GmbH + Co. KG bei Instagram">
                                <span class="sr-only">{{ __("lang.kwl.footer.instagram") }}</span>
                                <svg class="icon icon-sm">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.social.instagram"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://de.linkedin.com/company/helios-ventilatoren-gmbh-co-kg"
                                title="Helios Ventilatoren GmbH + Co. KG bei LinkedIn">
                                <span class="sr-only">{{ __("lang.kwl.footer.linkedin") }}</span>
                                <svg class="icon icon-sm">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.social.linkedin"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.xing.com/pages/heliosventilatorengmbh-cokg"
                                title="Helios Ventilatoren GmbH + Co. KG bei Xing">
                                <span class="sr-only">{{ __("lang.kwl.footer.xing") }}</span>
                                <svg class="icon icon-sm">
                                    <use xlink:href="/assets/img/icon-sprite.svg#global.social.xing"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-white" rel="noopener" target="_blank"
                                href="https://www.youtube.com/user/HeliosVentilatoren/"
                                title="Helios Ventilatoren GmbH + Co. KG bei Youtube">
                            <span class="sr-only">{{ __("lang.kwl.footer.youtube") }}</span>
                            <svg class="icon icon-sm">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.social.youtube"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        </nav>
        <div class="modal right fade" id="newsletterModal" tabindex="-1" role="dialog" aria-labelledby="newsletterModalLabel" aria-hidden="true">
                    <newsletterform :newsletteruser="propuser" @reset-newsletter-user="resetNewsletterUserInParent"></newsletterform>
        </div>
    </footer>
</template>

<script>
//import log from "@services/logger/index";
import newsletterform from './NewsletterForm'
import globalsApi from './services/api/globals'



export default {
    components: {
            newsletterform
        },
    data() {
        return {
            newsletter: {
                label: this.__('lang.kwl.footer.newsletter'),
                placeholder: this.__('lang.footer.newsletter.placeholder.email'),
            },

            invalidFeedback: {
                email: this.__('lang.newsletter.modal.invalidFeedback.email'),
            },
            input: {
                email: ''
            },
            propuser: {
                email: '',
                form_of_address_id: '',
                first_name: '',
                last_name: ''

            },
            contact: {
                href: {
                    phonenumber: this.__('lang.actionbutton.modal.contact.href.phonenumber'),
                    tocontactform: this.__('lang.actionbutton.modal.contact.href.tocontactform'),
                    tocontactpage: this.__('lang.actionbutton.modal.contact.href.tocontactpage')
                }
            },

        }
    },
    methods: {
        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        openNewsletterForm() {
            var salutation=''
            if (this.user.auth && (this.input.email == null || this.input.email == '')) {
                this.propuser.email = this.user.email
                switch (this.user.form_of_address_id) {
                    case 1:
                        salutation='Herr'
                        break;
                    case 2:
                        salutation = 'Frau'
                        break;
                    case 5:
                        salutation = 'Divers'
                        break;
                    default:
                        salutation = 'Herr'
                        break;
                }

                this.propuser.form_of_address_id = salutation//this.user.form_of_address_id
                this.propuser.first_name = this.user.first_name
                this.propuser.last_name = this.user.last_name
            }
            else if (this.user.auth && !(this.input.email == null || this.input.email == '')) {
                this.propuser.email = this.input.email
                this.propuser.form_of_address_id = null
                this.propuser.first_name = null
                this.propuser.last_name = null
            }
            else {
                this.propuser.email = this.input.email
                this.propuser.form_of_address_id = null
                this.propuser.first_name = null
                this.propuser.last_name = null
            }

            this.input.email = ''


            this.$nextTick(() => {
                // Watcher should trigger now
              /*   console.log('openNewsletterForm this.user.email', this.user.email)
                console.log('openNewsletterForm this.input.email', this.input.email)
                console.log('openNewsletterForm this.propuser.email', this.propuser.email) */
            });


        },
        resetNewsletterUserInParent(newNewsletterUser) {
            this.propuser = newNewsletterUser;
            /* console.log("resetNewsletterUserInParent", newNewsletterUser) */
        },

        async gottocontactpage() {
            var client
            var response = await globalsApi.getClients({ id: 5 });

            [client] = response.data
            if (response.status >= 400) {
                this.$store.dispatch('alert/setAlert', { type: 'danger', message: this.__('lang.floatactionbutton.alert.load_client_failed') })
                return
            }

            if (this.selectedlocale.country == 'aut') this.contact.href.tocontactpage = client.url + '/at/kontakt-at' //  this.__('lang.actionbutton.modal.contact.href.tocontactpage_at')
            else if (this.selectedlocale.country == 'deu' && this.selectedlocale.language == 'de') this.contact.href.tocontactpage = client.url + '/de/kontakt'//this.__('lang.actionbutton.modal.contact.href.tocontactpage_de')
            else if (this.selectedlocale.country == 'deu' && this.selectedlocale.language == 'en') this.contact.href.tocontactpage = client.url + '/en/contact'//this.__('lang.actionbutton.modal.contact.href.tocontactpage_en')
            var app_url = this.contact.href.tocontactpage
            setTimeout(() => {
                window.open(app_url, "_blank");
            })
        },

    },
    computed: {
        emailState() {
            if (this.input.email == null || this.input.email == '') return true
            return this.validateEmail(this.input.email)
        },
       user: {
            get() {
                return this.$store.state.user.user
            },
            set(value) {
                this.$store.commit('user/updateUser', value)
            }
        },
        selectedlocale: {
            get() {
                return this.$store.state.user.selectedlocale
            },
            set(value) {
                this.$store.commit('user/updateSelectedlocale', value)
            }
        }


    },
    watch: {

    },
    mounted() { },
};
</script>
